module.exports = __webpack_public_path__ + "static/media/now-hiring-mobile.2fc1a04b.jpg";